import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

export default new Vuex.Store({
   state: {
      teams: [],
      bowlers: [],
      currentGameEditorSettings: {
         bowler: null,
         team: null,
         date: null,
         game: null
      }
   },
   mutations: {
      SET_TEAMS: (state, _teams) => {
         state.teams = _teams
      },
      SET_BOWLERS: (state, _bowlers) => {
         state.bowlers = _bowlers
      },
      gameeditor_set_bowler: (state, b) => {
         state.currentGameEditorSettings.bowler = b
      },
      gameeditor_set_team: (state, t) => {
         state.currentGameEditorSettings.team = t
      },
      gameeditor_set_date: (state, d) => {
         state.currentGameEditorSettings.date = d
      },
      gameeditor_set_game: (state, g) => {
         state.currentGameEditorSettings.game = g
      },
   },
   actions: {
      getBowlers: async ({ commit }) => {
         let bowlers = [];
         await axios({
            method: "GET",
            url: "https://nostyleguy.com/api/bowlers"
         }).then(
            result => {
               for(let i in result.data) {
                  bowlers.push(result.data[i])
               }
            },
            error => {
               console.log("Error: " + error);
            }
         );
         commit('SET_BOWLERS', bowlers);
         return Promise.resolve();
      },
      getTeams: async ({ commit }) => {
         let teams = [];
         await axios({
            method: "GET",
            url: "https://nostyleguy.com/api/teams"
         }).then(
            result => {
               for(let i in result.data) {
                  teams.push(result.data[i])
               }
            },
            error => {
               console.log("Error: " + error);
            }
         );
         commit('SET_TEAMS', teams);
         return Promise.resolve();
      }
   },
   getters: {
      activeTeams: state => { return state.teams.filter(t => t.active) },
      inactiveTeams: state => { return state.teams.filter(t => !t.active) },
      activeBowlers: state => { return state.bowlers.filter(b =>b.active) },
      inactiveBowlers: state => { return state.bowlers.filter(b => !b.active) }
   }
})
